import React from 'react';

var DropdownSeparator = function DropdownSeparator() {
  return React.createElement("div", { className: "cf-dropdown__separator", role: "separator" });
};

export default DropdownSeparator;


//////////////////
// WEBPACK FOOTER
// ./node_modules/cf-component-dropdown/es/DropdownSeparator.js
// module id = 957
// module chunks = 0